import { performRequestSecond } from 'common/apiHandler';
import { default as apiEndPoints } from 'common/apiEndPoints';
import { getTenantDetails } from 'utils/utils';

export const updateWorkFlowAutomationRules = (action_item_update = false, data) => {
  const [tenantId, tenantSk] = getTenantDetails();
  let url = `${apiEndPoints.updateAutomationRules}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&action_item_update=${action_item_update}`;
  return performRequestSecond(apiEndPoints.methodType.PUT, url, data);
};
export const getWorkFlowAutomationRuleDetails = (pk, sk) => {
  const [tenantId, tenantSk] = getTenantDetails();
  const pkModified = pk?.replaceAll('#', '%23');
  const skModified = sk?.replaceAll('#', '%23');
  let url = `${apiEndPoints.getAutomationRuleDetails}?tenant_id=${tenantId}&tenant_sk=${tenantSk}&pk=${pkModified}&sk=${skModified}`;
  return performRequestSecond(apiEndPoints.methodType.GET, url);
};
